import { render, staticRenderFns } from "./alumni.vue?vue&type=template&id=5e9ee39e"
import script from "./alumni.vue?vue&type=script&lang=js"
export * from "./alumni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports